import React, { useState } from 'react'
import './index.scss';
import {
    faAngular,
    faCss3,
    faGitAlt,
    faHtml5,
    faJsSquare,
    faLinkedin,
    faGithub,
    faTwitter,
    faReact,
    faInstagram
} from '@fortawesome/free-brands-svg-icons'
import AnimatedLetters from '../AnimatedLetters';
import Loader from 'react-loaders'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react';
const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, 4000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);
    return (
        <>
            <div className='container about-contact-page'>
                <div className='text-zone'>
                    <h1 className='page-title'>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        My name is Eformeh Wisdom, a versatile Fullstack Developer based in Lagos, Nigeria.
                        My passion lies at the intersection of development and design, with a touch of DevOps expertise.
                        I constantly seek to learn new technologies, broaden my skillset,
                        and add significant value in diverse areas of the tech landscape.
                    </p>
                    <p align="LEFT">
                        I'm quiet, naturally curious, and perpetually working on
                        improving my chops one bug at a time.
                    </p>

                    <p>
                        Learning Focus: I am dedicated to contributing to the open-source community, sharing knowledge, and collaborating with fellow developers.
                    </p>
                    <p>
                        Languages I'm proficient in  includes HTML, CSS, JavaScript, Python, Java, PHP, and C++. I also have experience with a variety of technologies like ReactJs, NextJs, Angular, NestJS, Laravel, ExpressJs, and MongoDB.
                    </p>
                    <p>
                        Feel free to reach out and connect through any of my social media profiles!
                        <ul className='social-icons'>
                            <li>
                                <a target="_blank" rel='noreferrer' href='https://www.linkedin.com/in/wisdom-eformeh-bello-341166203/'>
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </a>
                            </li>
                            <li>
                                <a target="_blank" rel='noreferrer' href='https://github.com/eformeh'>
                                    <FontAwesomeIcon icon={faGithub} />
                                </a>
                            </li>
                            <li>
                                <a target="_blank" rel='noreferrer' href='https://twitter.com/oy_grey'>
                                    <FontAwesomeIcon icon={faTwitter} />
                                </a>
                            </li>
                            <li>
                                <a target="_blank" rel='noreferrer' href='https://www.instagram.com/oyievesho.e/'>
                                    <FontAwesomeIcon icon={faInstagram} />
                                </a>
                            </li>
                        </ul>
                    </p>
                </div>
                <div className='stage-cube-cont'>
                    <div className="stage-cube-cont">
                        <div className="cubespinner">
                            <div className="face1">
                                <FontAwesomeIcon icon={faAngular} color="#DD0031" />
                            </div>
                            <div className="face2">
                                <FontAwesomeIcon icon={faHtml5} color="#F06529" />
                            </div>
                            <div className="face3">
                                <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                            </div>
                            <div className="face4">
                                <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                            </div>
                            <div className="face5">
                                <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                            </div>
                            <div className="face6">
                                <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default About